/**
 * Helpers pour les chaînes srcset densité (format "url 1x, url 2x").
 */

/**
 * Extrait la première URL d'un srcset densité (variante 1x en général).
 * Utile pour l'attribut src de fallback <img>.
 */
export function firstUrlFromDensitySrcset(srcset: string | null | undefined): string {
  if (!srcset) {
    return '';
  }

  const firstEntry = String(srcset).split(',')[0]?.trim() ?? '';
  return firstEntry.split(/\s+/)[0] ?? '';
}

/**
 * Indique si la chaîne contient les descripteurs 1x et 2x.
 */
export function hasDensityDescriptors(srcset: string | null | undefined): boolean {
  if (!srcset) {
    return false;
  }

  return /\s1x\b/.test(srcset) && /\s2x\b/.test(srcset);
}
